<ng-content></ng-content>
<app-pagination [pageRequest]="pageRequest" (pageChange)="onPageChange($event)" [refresh]="onRefresh"></app-pagination>